export const blockIconsCommunicationPersonSearchNew = (
	<span className='material-symbols-outlined'>person_search</span>
);
